import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=285cc789&scoped=true&"
import script from "./specialDetail.vue?vue&type=script&lang=js&"
export * from "./specialDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialDetail.vue?vue&type=style&index=0&id=285cc789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285cc789",
  null
  
)

export default component.exports